import {EventEmitter} from '@billjs/event-emitter';
import { gsap } from "gsap";


export default class UI extends EventEmitter{

  constructor() {
    super();

  }

  init(){

    let loadingLetters = document.querySelectorAll("#landing-loading span");
    loadingLetters.forEach((item, i) => {
      item.style.transitionDelay = (i * .1) + "s";
    });


    let startEls = document.querySelectorAll("#landing-title-page .start-item");
    startEls.forEach((item, i) => {
      setTimeout(()=>{item.classList.add("show");},500 + (i*100));
    });


    window.addEventListener('resize', function () {
      if (this.cssTimer){
        clearTimeout(this.cssTimer);
        this.cssTimer = null;
      }else{
        document.getElementById('landing').classList.add('stop-transitions');

        this.cssTimer = setTimeout(() => {
            document.getElementById('landing').classList.remove('stop-transitions');
            this.cssTimer  = null;
        }, 100);
      }
    }.bind(this));


  }

  openDoors(){

    document.querySelector("#landing-door").classList.add("open");
    document.querySelector("#landing-door").classList.add("zoom");
    document.getElementById("landing").style.borderLeft = "10px solid transparent";
    document.getElementById("landing").style.borderRight = "10px solid transparent";
    document.getElementById("landing-loading").classList.remove("show");
    // document.getElementById("landing-text").classList.add("hide");
    document.getElementById("landing-enter").classList.add("hide");
    document.getElementById("landing-about").style.display = "none";//.add("hide");
    document.getElementById("home-video-container").style.display = "none";//.add("hide");
  }


  closeDoors(){
    document.querySelector("#landing-door").classList.remove("open");
    document.querySelector("#landing-door").classList.add("close");

    // document.querySelector("#landing-door").classList.add("zoom");

    document.getElementById("landing-door").style.opacity = 1;
  }


  startWorldLoadingAnimation(){
    document.getElementById("landing-loading").classList.add("show");

    let loadingLetters = document.querySelectorAll("#landing-loading span");
    loadingLetters.forEach((item, i) => {
      item.classList.add("show")
    });


  }

  pauseWorldLoadingAnimation(){

    let curtains = document.querySelectorAll('.curtain');
    curtains.forEach((item, i) => {
      item.classList.add('loaded');
    });


  }

  showPage(id){
    let currentPage = document.querySelector(".page.active");
    let newPage = document.getElementById(id);

    this.prevPage = currentPage;
    this.currPage = newPage;

    currentPage.classList.remove("active");
    currentPage.classList.add("hidden");
    newPage.classList.add("active");

    if( id == "main-world"){
      let threeScene = document.getElementById("three-scene");
      threeScene.classList.remove("animate-out");
    }

  }

  showTab(id,buttonId){
    let tabs = document.querySelectorAll(".popup-tab");
    tabs.forEach((item, i) => {
      item.classList.remove("active");
    });

    let activeTab = document.getElementById(id);
    activeTab.classList.add("active");

    let buttons = document.querySelectorAll(".tab-option-buttons button");
    buttons.forEach((item, i) => {
      item.classList.remove("active");
    });

    let activeButton = document.getElementById(buttonId);
    activeButton.classList.add("active");
  }

};
